import React, { lazy } from 'react';
export function HowItWorks() {
  return <section className="bg-gray-50 py-8 sm:py-12 md:py-16" data-id="element-246">
      <div className="max-w-6xl mx-auto px-4" data-id="element-247">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-8 sm:mb-12" data-id="element-248">
          De Caos a Calma en 3 Pasos
        </h2>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8" data-id="element-249">
          <div className="text-center" data-id="element-250">
            <div className="w-full h-40 sm:h-48 md:h-64 bg-gray-200 rounded-lg sm:rounded-xl mb-3 sm:mb-4 overflow-hidden" data-id="element-251">
              <img src="https://cdn.magicpatterns.com/uploads/oUWYW9WhbbXvaFNtumtT1w/bath_cooking.png" alt="Batch Cooking" loading="lazy" className="w-full h-full object-cover" data-id="element-252" />
            </div>
            <h3 className="font-bold text-base sm:text-lg md:text-xl mb-2" data-id="element-253">
              1. Batch Cooking Domingo
            </h3>
            <p className="text-xs sm:text-sm md:text-base text-gray-700 px-2" data-id="element-254">
              60 minutos para preparar todas las bases de la semana. Arroz,
              proteínas, verduras cortadas. Todo listo para ensamblar.
            </p>
          </div>
          <div className="text-center" data-id="element-255">
            <div className="w-full h-40 sm:h-48 md:h-64 bg-gray-200 rounded-lg sm:rounded-xl mb-3 sm:mb-4 overflow-hidden" data-id="element-256">
              <img src="https://cdn.magicpatterns.com/uploads/84qjEmRKY4cHnBMsEdV2dN/ChatGPT_Image_Dec_11,_2025,_06_18_00_PM.png" alt="Cocina 15 minutos" loading="lazy" className="w-full h-full object-cover" data-id="element-257" />
            </div>
            <h3 className="font-bold text-base sm:text-lg md:text-xl mb-2" data-id="element-258">
              2. Cocina en 15 Minutos
            </h3>
            <p className="text-xs sm:text-sm md:text-base text-gray-700 px-2" data-id="element-259">
              Cada tarde, solo ensambla. Sigue la receta del día, usa lo que ya
              preparaste, y en 15 minutos: ¡a la mesa!
            </p>
          </div>
          <div className="text-center sm:col-span-2 md:col-span-1" data-id="element-260">
            <div className="w-full h-40 sm:h-48 md:h-64 bg-gray-200 rounded-lg sm:rounded-xl mb-3 sm:mb-4 overflow-hidden" data-id="element-261">
              <img src="https://cdn.magicpatterns.com/uploads/iYcYbWAjPJnFcNMkL5jmUN/ChatGPT_Image_Dec_11,_2025,_07_12_20_PM.png" alt="Familia feliz" loading="lazy" className="w-full h-full object-cover" data-id="element-262" />
            </div>
            <h3 className="font-bold text-base sm:text-lg md:text-xl mb-2" data-id="element-263">
              3. Disfruta la Calma
            </h3>
            <p className="text-xs sm:text-sm md:text-base text-gray-700 px-2" data-id="element-264">
              Sin estrés. Sin protestas. Sin delivery de emergencia. Solo tiempo
              de calidad con tu familia y comida que todos aman.
            </p>
          </div>
        </div>
      </div>
    </section>;
}